//CSS
import "../../Components/Page/Page.css";
import "./TimeLine.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReadMore from "../../Components/ReadMore/ReadMore";
import { ArticleElement } from "../../Components/Article/ArticleComp";
import NewsReleases from "../../Components/Article/NewsReleases.json";
import Button2 from "../../Components/Button2/Button2";

interface TimelineText {
  headLine: string;
  text: string;
  readMore: string;
}


const TimeLine: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="News Releases" />
      <SubSection isSplit={false}>
        <div className="description-container">
          {NewsReleases.map((item, index) => (
            <div key={index}>
              <div className="news-header">
                <FontAwesomeIcon
                  className="news-icon"
                  icon={faNewspaper}
                  size="2x"
                />
                <b className="news-title">
                  {item.publishedAt
                    ? new Date(item.publishedAt).toLocaleDateString("en-US", {
                        month: "long",
                        year: "numeric",
                      })
                    : null}{" "}
                  - {item.title}
                </b>
              </div>

              <p>{item.excerpt}</p>
              <Button2
                name="readMore"
                text="Read more..."
                href={`/article/${item.slug}`}
                classname="ctaButton"
              />
              <br />
            </div>
          ))}
        </div>
      </SubSection>
    </div>
  );
};

export default TimeLine;
